"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("../geom/Location"));

var _Position = _interopRequireDefault(require("./Position"));

var _TopologyException = _interopRequireDefault(require("../geom/TopologyException"));

var _EdgeEndStar2 = _interopRequireDefault(require("./EdgeEndStar"));

var _System = _interopRequireDefault(require("../../../../java/lang/System"));

var _Label = _interopRequireDefault(require("./Label"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _Quadrant = _interopRequireDefault(require("./Quadrant"));

var _Assert = _interopRequireDefault(require("../util/Assert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DirectedEdgeStar =
/*#__PURE__*/
function (_EdgeEndStar) {
  _inherits(DirectedEdgeStar, _EdgeEndStar);

  function DirectedEdgeStar() {
    var _this;

    _classCallCheck(this, DirectedEdgeStar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DirectedEdgeStar).call(this));
    DirectedEdgeStar.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(DirectedEdgeStar, [{
    key: "linkResultDirectedEdges",
    value: function linkResultDirectedEdges() {
      this.getResultAreaEdges();
      var firstOut = null;
      var incoming = null;
      var state = this._SCANNING_FOR_INCOMING;

      for (var i = 0; i < this._resultAreaEdgeList.size(); i++) {
        var nextOut = this._resultAreaEdgeList.get(i);

        var nextIn = nextOut.getSym();
        if (!nextOut.getLabel().isArea()) continue;
        if (firstOut === null && nextOut.isInResult()) firstOut = nextOut;

        switch (state) {
          case this._SCANNING_FOR_INCOMING:
            if (!nextIn.isInResult()) continue;
            incoming = nextIn;
            state = this._LINKING_TO_OUTGOING;
            break;

          case this._LINKING_TO_OUTGOING:
            if (!nextOut.isInResult()) continue;
            incoming.setNext(nextOut);
            state = this._SCANNING_FOR_INCOMING;
            break;
        }
      }

      if (state === this._LINKING_TO_OUTGOING) {
        if (firstOut === null) throw new _TopologyException.default("no outgoing dirEdge found", this.getCoordinate());

        _Assert.default.isTrue(firstOut.isInResult(), "unable to link last incoming dirEdge");

        incoming.setNext(firstOut);
      }
    }
  }, {
    key: "insert",
    value: function insert(ee) {
      var de = ee;
      this.insertEdgeEnd(de, de);
    }
  }, {
    key: "getRightmostEdge",
    value: function getRightmostEdge() {
      var edges = this.getEdges();
      var size = edges.size();
      if (size < 1) return null;
      var de0 = edges.get(0);
      if (size === 1) return de0;
      var deLast = edges.get(size - 1);
      var quad0 = de0.getQuadrant();
      var quad1 = deLast.getQuadrant();
      if (_Quadrant.default.isNorthern(quad0) && _Quadrant.default.isNorthern(quad1)) return de0;else if (!_Quadrant.default.isNorthern(quad0) && !_Quadrant.default.isNorthern(quad1)) return deLast;else {
        var nonHorizontalEdge = null;
        if (de0.getDy() !== 0) return de0;else if (deLast.getDy() !== 0) return deLast;
      }

      _Assert.default.shouldNeverReachHere("found two horizontal edges incident on node");

      return null;
    }
  }, {
    key: "print",
    value: function print(out) {
      _System.default.out.println("DirectedEdgeStar: " + this.getCoordinate());

      for (var it = this.iterator(); it.hasNext();) {
        var de = it.next();
        out.print("out ");
        de.print(out);
        out.println();
        out.print("in ");
        de.getSym().print(out);
        out.println();
      }
    }
  }, {
    key: "getResultAreaEdges",
    value: function getResultAreaEdges() {
      if (this._resultAreaEdgeList !== null) return this._resultAreaEdgeList;
      this._resultAreaEdgeList = new _ArrayList.default();

      for (var it = this.iterator(); it.hasNext();) {
        var de = it.next();
        if (de.isInResult() || de.getSym().isInResult()) this._resultAreaEdgeList.add(de);
      }

      return this._resultAreaEdgeList;
    }
  }, {
    key: "updateLabelling",
    value: function updateLabelling(nodeLabel) {
      for (var it = this.iterator(); it.hasNext();) {
        var de = it.next();
        var label = de.getLabel();
        label.setAllLocationsIfNull(0, nodeLabel.getLocation(0));
        label.setAllLocationsIfNull(1, nodeLabel.getLocation(1));
      }
    }
  }, {
    key: "linkAllDirectedEdges",
    value: function linkAllDirectedEdges() {
      this.getEdges();
      var prevOut = null;
      var firstIn = null;

      for (var i = this._edgeList.size() - 1; i >= 0; i--) {
        var nextOut = this._edgeList.get(i);

        var nextIn = nextOut.getSym();
        if (firstIn === null) firstIn = nextIn;
        if (prevOut !== null) nextIn.setNext(prevOut);
        prevOut = nextOut;
      }

      firstIn.setNext(prevOut);
    }
  }, {
    key: "computeDepths",
    value: function computeDepths() {
      if (arguments.length === 1) {
        var de = arguments[0];
        var edgeIndex = this.findIndex(de);
        var label = de.getLabel();
        var startDepth = de.getDepth(_Position.default.LEFT);
        var targetLastDepth = de.getDepth(_Position.default.RIGHT);
        var nextDepth = this.computeDepths(edgeIndex + 1, this._edgeList.size(), startDepth);
        var lastDepth = this.computeDepths(0, edgeIndex, nextDepth);
        if (lastDepth !== targetLastDepth) throw new _TopologyException.default("depth mismatch at " + de.getCoordinate());
      } else if (arguments.length === 3) {
        var startIndex = arguments[0],
            endIndex = arguments[1],
            _startDepth = arguments[2];
        var currDepth = _startDepth;

        for (var i = startIndex; i < endIndex; i++) {
          var nextDe = this._edgeList.get(i);

          var label = nextDe.getLabel();
          nextDe.setEdgeDepths(_Position.default.RIGHT, currDepth);
          currDepth = nextDe.getDepth(_Position.default.LEFT);
        }

        return currDepth;
      }
    }
  }, {
    key: "mergeSymLabels",
    value: function mergeSymLabels() {
      for (var it = this.iterator(); it.hasNext();) {
        var de = it.next();
        var label = de.getLabel();
        label.merge(de.getSym().getLabel());
      }
    }
  }, {
    key: "linkMinimalDirectedEdges",
    value: function linkMinimalDirectedEdges(er) {
      var firstOut = null;
      var incoming = null;
      var state = this._SCANNING_FOR_INCOMING;

      for (var i = this._resultAreaEdgeList.size() - 1; i >= 0; i--) {
        var nextOut = this._resultAreaEdgeList.get(i);

        var nextIn = nextOut.getSym();
        if (firstOut === null && nextOut.getEdgeRing() === er) firstOut = nextOut;

        switch (state) {
          case this._SCANNING_FOR_INCOMING:
            if (nextIn.getEdgeRing() !== er) continue;
            incoming = nextIn;
            state = this._LINKING_TO_OUTGOING;
            break;

          case this._LINKING_TO_OUTGOING:
            if (nextOut.getEdgeRing() !== er) continue;
            incoming.setNextMin(nextOut);
            state = this._SCANNING_FOR_INCOMING;
            break;
        }
      }

      if (state === this._LINKING_TO_OUTGOING) {
        _Assert.default.isTrue(firstOut !== null, "found null for first outgoing dirEdge");

        _Assert.default.isTrue(firstOut.getEdgeRing() === er, "unable to link last incoming dirEdge");

        incoming.setNextMin(firstOut);
      }
    }
  }, {
    key: "getOutgoingDegree",
    value: function getOutgoingDegree() {
      if (arguments.length === 0) {
        var degree = 0;

        for (var it = this.iterator(); it.hasNext();) {
          var de = it.next();
          if (de.isInResult()) degree++;
        }

        return degree;
      } else if (arguments.length === 1) {
        var er = arguments[0];
        var degree = 0;

        for (var it = this.iterator(); it.hasNext();) {
          var de = it.next();
          if (de.getEdgeRing() === er) degree++;
        }

        return degree;
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this._label;
    }
  }, {
    key: "findCoveredLineEdges",
    value: function findCoveredLineEdges() {
      var startLoc = _Location.default.NONE;

      for (var it = this.iterator(); it.hasNext();) {
        var nextOut = it.next();
        var nextIn = nextOut.getSym();

        if (!nextOut.isLineEdge()) {
          if (nextOut.isInResult()) {
            startLoc = _Location.default.INTERIOR;
            break;
          }

          if (nextIn.isInResult()) {
            startLoc = _Location.default.EXTERIOR;
            break;
          }
        }
      }

      if (startLoc === _Location.default.NONE) return null;
      var currLoc = startLoc;

      for (var it = this.iterator(); it.hasNext();) {
        var nextOut = it.next();
        var nextIn = nextOut.getSym();

        if (nextOut.isLineEdge()) {
          nextOut.getEdge().setCovered(currLoc === _Location.default.INTERIOR);
        } else {
          if (nextOut.isInResult()) currLoc = _Location.default.EXTERIOR;
          if (nextIn.isInResult()) currLoc = _Location.default.INTERIOR;
        }
      }
    }
  }, {
    key: "computeLabelling",
    value: function computeLabelling(geom) {
      _get(_getPrototypeOf(DirectedEdgeStar.prototype), "computeLabelling", this).call(this, geom);

      this._label = new _Label.default(_Location.default.NONE);

      for (var it = this.iterator(); it.hasNext();) {
        var ee = it.next();
        var e = ee.getEdge();
        var eLabel = e.getLabel();

        for (var i = 0; i < 2; i++) {
          var eLoc = eLabel.getLocation(i);
          if (eLoc === _Location.default.INTERIOR || eLoc === _Location.default.BOUNDARY) this._label.setLocation(i, _Location.default.INTERIOR);
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DirectedEdgeStar;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return DirectedEdgeStar;
}(_EdgeEndStar2.default);

exports.default = DirectedEdgeStar;

DirectedEdgeStar.constructor_ = function () {
  this._resultAreaEdgeList = null;
  this._label = null;
  this._SCANNING_FOR_INCOMING = 1;
  this._LINKING_TO_OUTGOING = 2;
};